import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import Button from '@everlane/button'

import TimedButton from 'base/components/ui/timed_button'
import apiUrl from 'base/api_url'
import { post } from 'base/lib/network'
import { sendPasswordResetEmail } from 'base/actions/asynchronous'
import Input from 'base/react/components/form/input'
import { getErrorsForUserAccountData } from 'base/validators'

function MagicLinkSignIn({
  initialEmail = '',
  siteLocation,
  isPasswordlessUser,
  onServerError,
  onClickSwitchToPassword,
}) {
  const dispatch = useDispatch()
  const [email, setEmail] = useState(initialEmail)
  const [showSentMessage, setShowSentMessage] = useState(false)
  const [emailError, setEmailError] = useState(null)

  const emailField = () => {
    return (
      <Input
        label="Email"
        error={emailError}
        placeholder="Enter email address"
        autoComplete="email"
        type="email"
        value={email}
        onChange={event => setEmail(event.target.value)}
        onBlur={() => setEmailError(getErrorsForUserAccountData({ email }).email)}
      />
    )
  }

  const handleCreateLink = event => {
    event.preventDefault()
    return emailError
      ? null
      : post(apiUrl('magic_links'), {
          login: { email, siteLocation },
        })
          .catch(onServerError)
          .always(() => setShowSentMessage(true))
  }

  const createLinkButton = () => {
    return (
      <Button className="magic-link-sign-in__flat-button" type="submit" variant="rectangle" dark>
        Log In Without Password
      </Button>
    )
  }

  const bottomCta = () => {
    if (isPasswordlessUser) {
      return (
        <TimedButton
          variant="rectangle"
          className="magic-link-sign-in__flat-button"
          text="Send Password Reset Email"
          timedText="Check Your Email"
          onClick={() => dispatch(sendPasswordResetEmail(email))}
        />
      )
    }
    return (
      <Button
        className="magic-link-sign-in__flat-button"
        onClick={onClickSwitchToPassword}
        variant="rectangle"
      >
        Log In With Password
      </Button>
    )
  }

  const sentMessage = () => {
    return (
      <div className="magic-link-sign-in__wrapper">
        <p className="magic-link-sign-in__message">
          {`We sent a log in link to ${email}. If you don’t see this email,
          please check your spam folder.`}
        </p>
        <TimedButton
          className="magic-link-sign-in__flat-button"
          text="Resend Log In Link"
          timedText="Check Your Email"
          onClick={() => {
            post(apiUrl('magic_links'), {
              login: { email, siteLocation },
            }).catch(onServerError)
          }}
          variant="rectangle"
          dark
        />
        <div className="magic-link-sign-in__link-wrapper">
          <button
            className="magic-link-sign-in__button"
            onClick={() => {
              setShowSentMessage(false)
            }}
          >
            Go back to log in
          </button>
        </div>
      </div>
    )
  }

  const signInForm = () => {
    return (
      <div className="magic-link-sign-in__wrapper">
        <form onSubmit={handleCreateLink}>
          {emailField()}
          {createLinkButton()}
        </form>
        <p className="magic-link-sign-in__caption">We’ll send a log in link to your inbox</p>
        <p className="magic-link-sign-in__or">Or</p>
        {bottomCta()}
      </div>
    )
  }

  return showSentMessage ? sentMessage() : signInForm()
}

export default MagicLinkSignIn

MagicLinkSignIn.propTypes = {
  initialEmail: PropTypes.string,
  siteLocation: PropTypes.string,
  isPasswordlessUser: PropTypes.bool.isRequired,
  onClickSwitchToPassword: PropTypes.func.isRequired,
}
